import { H1, H2, H5, Image, PortableText, Section } from '@ahmdigital/ui';
import { isEmpty } from 'lodash/fp';
import generatePortableText from '@ahmdigital/logic/lib/content/utils/generate-portable-text';
// @ts-expect-error - Automatic, Please fix when editing this file
import getAllRewards from '@ahmdigital/offers/lib/model/offer/get-all-rewards';
import getHeader from '@ahmdigital/logic/lib/content/offers/unqualified/get-header';
import getReleasePeriod from '@ahmdigital/logic/lib/content/offers/terms-and-conditions/get-release-period';

import { Offer, Placeholder } from '../../../../../components/offers/types';
import getOfferImage from '../../../../../components/offers/utils/get-offer-image';
import placeholderSerializer from '../../../../../components/offers/serializers/placeholder';
import styles from './styles.module.sass';

type ImageHeaderProps = {
  offer: Offer;
  placeholders: Placeholder[];
};

const ImageHeader = ({ offer, placeholders }: ImageHeaderProps) => {
  const image = getOfferImage(offer);
  const release = {
    endTime: offer.release?.endTime,
    startTime: offer.release?.startTime,
  };
  return (
    <Section variant={[styles.wrapper, 'paddingTopSpacerNone', 'paddingBottomSpacer2']}>
      <div className={styles.imageWrapper}>
        {image && <Image className={styles.image} src={image.src} alt={image.alt} />}
      </div>
      <div className={styles.contentWrapper}>
        <H1 variant="marginBottomSpacer9">Offer terms & conditions</H1>
        <H2 looksLike="h4" variant="marginBottomSpacer10">
          <PortableText
            source={generatePortableText(getHeader(offer))}
            typeSerializers={{
              placeholder: placeholderSerializer({
                offer,
                placeholders,
                rewards: getAllRewards(offer),
              }),
            }}
          />
        </H2>
        {!isEmpty(offer.release) && <H5 variant="regular">{getReleasePeriod({ release })}</H5>}
      </div>
    </Section>
  );
};

export default ImageHeader;
